/* Cart drawer complementary products upsell.
   Uses Shopify Search & Discovery complementary products.
   Added by Claude – safe to remove. */
(function () {
  'use strict';
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  var style = document.createElement('style');
  style.textContent = [
    '.cart-upsell{padding:14px 2px 2px;margin-top:10px;border-top:1px solid rgba(0,0,0,.12);}',
    '.cart-upsell__title{font-weight:700;font-size:.78rem;text-transform:uppercase;letter-spacing:.05em;margin:0 0 10px;}',
    '.cart-upsell__item{display:flex;align-items:center;gap:10px;margin-bottom:10px;}',
    '.cart-upsell__item img{width:54px;height:54px;object-fit:cover;border-radius:6px;flex:none;}',
    '.cart-upsell__info{flex:1;min-width:0;display:block;}',
    '.cart-upsell__name{font-size:.85rem;line-height:1.3;display:block;color:inherit;text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '.cart-upsell__price{font-size:.8rem;opacity:.75;}',
    '.cart-upsell__add{flex:none;border:1px solid currentColor;background:none;color:inherit;border-radius:999px;padding:5px 14px;font-size:.8rem;cursor:pointer;font-family:inherit;}',
    '.cart-upsell__add:disabled{opacity:.5;cursor:default;}',
    'product-recommendations[data-intent="complementary"] .resource-list:has(.resource-list__item a)::before{content:"Perfect together";display:block;grid-column:1/-1;font-weight:700;font-size:.78rem;text-transform:uppercase;letter-spacing:.05em;}',
    'product-recommendations[data-intent="complementary"] .resource-list{grid-template-columns:repeat(2,minmax(0,1fr));}',
    'product-recommendations[data-intent="complementary"] .resource-list__item h3{display:none;}',
    '.shopify-section[id*="logo_Rpw4dD"] .jumbo-text-line, .shopify-section[id*="logo_Rpw4dD"] .jumbo-text{color:transparent;background-color:#F4A7B9;background-image:radial-gradient(rgba(255,255,255,.55) 1.6px, transparent 1.8px),radial-gradient(rgba(255,255,255,.3) 1.6px, transparent 1.8px);background-size:26px 26px;background-position:0 0,13px 13px;-webkit-background-clip:text;background-clip:text;}',
    '.shopify-section[id*="marquee"] :is(h1,h2,p,a,span){color:#ffffff !important;}',
    '.gelato-dots, .shopify-section[id*="featured_product"] .section-background{background-image:radial-gradient(rgba(255,255,255,.5) 1.6px, transparent 1.8px),radial-gradient(rgba(255,255,255,.28) 1.6px, transparent 1.8px) !important;background-size:26px 26px !important;background-position:0 0,13px 13px !important;}',
    '.header-menu .overflow-menu{flex-wrap:wrap;row-gap:2px;}',
    /* one-row-header */ '/* gc-square-fix */ .product-media-container:has(img[src*="gift-card-square"]){aspect-ratio:1/1 !important;}',
     '@media (min-width: 990px){ /* one-row-full */ header-component.header > .header__row--bottom{grid-template-columns:18px minmax(0,1fr) 6px !important;} header-component.header > .header__row--bottom .header__columns{grid-template-columns:minmax(0,1fr) !important;column-gap:0 !important;} }',
     '@media (min-width: 990px) and (max-width: 1649px){ /* one-row-tier2 */ header-component.header .header-menu a{font-size:.7rem !important;letter-spacing:.01em;} .header-menu .overflow-menu{column-gap:9px !important;} header-component.header > .header__row--top .header__column--right{column-gap:6px;} }',
     '@media (min-width: 990px){ /* one-row-tight */ header-component.header .header-menu a{font-size:.78rem;} .header-menu .overflow-menu{column-gap:13px;} header-component.header > .header__row--bottom .header__columns{padding-inline:18px 8px;} header-component.header > .header__row--top .header__columns{padding-inline:8px 18px;} }',
     '@media (min-width: 990px){ header-component.header{display:grid !important;grid-template-columns:minmax(0,1fr) auto;align-items:center;} header-component.header > .header__row--bottom{grid-column:1;grid-row:1;} header-component.header > .header__row--top{grid-column:2;grid-row:1;} header-component.header > .header__row--top .header__column--left, header-component.header > .header__row--top .header__column--center{display:none;} header-component.header > .header__row--top .header__columns{grid-template-columns:auto !important;} }',
    /* featured-slide-fix */ '.shopify-section[id*="featured_product"] product-card slideshow-slide img, .shopify-section[id*="featured_product"] product-card deferred-media img, .shopify-section[id*="featured_product"] product-card .deferred-media__poster-image{object-fit:cover !important;width:100% !important;height:100% !important;border-radius:16px;}',
    '.hover-preview-video{border-radius:inherit;}',
    '.shopify-section[id*="featured_product"] .product-media, .shopify-section[id*="featured_product"] .product-media__image, .shopify-section[id*="featured_product"] slideshow-slide, .shopify-section[id*="featured_product"] deferred-media, .shopify-section[id*="featured_product"] video, .shopify-section[id*="featured_product"] iframe{border-radius:16px;overflow:hidden;}',
    'product-recommendations[data-intent="complementary"] slideshow-arrows{display:contents !important;}',
    'product-recommendations[data-intent="complementary"] slideshow-arrows .slideshow-control{--icon-stroke-width:1.5px;color:#111;position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:34px;height:34px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.92);border:none;border-radius:50%;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.15);}',
    'product-recommendations[data-intent="complementary"] slideshow-arrows .slideshow-control:first-child{left:8px;}',
    'product-recommendations[data-intent="complementary"] slideshow-arrows .slideshow-control:last-child{right:8px;}',
    'product-recommendations[data-intent="complementary"] slideshow-arrows .slideshow-control svg{width:16px;height:16px;}',
    '.product-badges__badge{background-color:#F4A7B9 !important;background-image:radial-gradient(rgba(255,255,255,.5) 1.4px, transparent 1.6px),radial-gradient(rgba(255,255,255,.28) 1.4px, transparent 1.6px);background-size:18px 18px;background-position:0 0,9px 9px;color:#ffffff !important;font-size:1rem;font-weight:700;letter-spacing:.06em;padding:8px 18px;border-radius:8px;}',
    '.shopify-section[id*="marquee"] .section-background{background-color:#F4A7B9 !important;background-image:radial-gradient(rgba(255,255,255,.55) 1.6px, transparent 1.8px),radial-gradient(rgba(255,255,255,.3) 1.6px, transparent 1.8px);background-size:26px 26px;background-position:0 0,13px 13px;}'
  ].join('');
  document.head.appendChild(style);

  var busy = false;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function fetchJSON(u, opts) {
    return fetch(u, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function pickUpsells(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var chain = Promise.resolve([]);
    cart.items.forEach(function (item) {
      chain = chain.then(function (found) {
        if (found.length) return found;
        return fetchJSON('/recommendations/products.json?product_id=' + item.product_id + '&limit=6&intent=complementary')
          .then(function (j) {
            var prods = (j.products || []).filter(function (p) { return !inCart[p.id] && p.available !== false; });
            return prods.slice(0, 2);
          })
          .catch(function () { return []; });
      });
    });
    return chain;
  }

  function imgUrl(p) {
    var img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && (p.featured_image.url || p.featured_image.src)) || '';
    if (img && img.indexOf('?') === -1 && img.indexOf('cdn.shopify.com') > -1) img += '?width=120';
    return img;
  }

  function addToCart(p, btn) {
    btn.disabled = true;
    btn.textContent = '…';
    var getVariant;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    if (v) {
      getVariant = Promise.resolve(v.id);
    } else {
      getVariant = fetchJSON(p.url.split('?')[0] + '.js').then(function (pj) {
        var vv = pj.variants.filter(function (x) { return x.available; })[0] || pj.variants[0];
        return vv.id;
      });
    }
    getVariant.then(function (variantId) {
      return fetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    }).then(function () {
      return refreshDrawer();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  }

  function refreshDrawer() {
    var secEl = document.getElementById('shopify-section-cart-drawer-section');
    if (!secEl) return Promise.resolve();
    return fetch('/?sections=cart-drawer-section').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['cart-drawer-section'];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var curDialog = secEl.querySelector('dialog');
      var freshDialog = tmp.querySelector('dialog');
      if (curDialog && freshDialog) {
        curDialog.innerHTML = freshDialog.innerHTML;
      } else {
        secEl.innerHTML = html;
      }
      return fetchJSON('/cart.js').then(function (cart) {
        document.querySelectorAll('.cart-bubble, [class*="cart-bubble"]').forEach(function (b) {
          var numEl = b.querySelector('[aria-hidden]') || b;
          if (/^\d*$/.test(numEl.textContent.trim())) numEl.textContent = cart.item_count;
        });
      }).catch(function () {});
    }).then(function () { setTimeout(update, 50); }).catch(function () {});
  }

  function target() {
    var inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return null;
    var sum = inner.querySelector('.cart-drawer__summary');
    if (sum) return { parent: sum.parentElement, before: sum };
    return { parent: inner, before: null };
  }

  function update() {
    if (busy) return;
    busy = true;
    Promise.resolve().then(function () {
      var t = target();
      if (!t) return;
      return fetchJSON('/cart.js').then(function (cart) {
        var box = document.querySelector('.cart-upsell');
        if (!cart.items.length) { if (box) box.remove(); return; }
        var key = cart.items.map(function (i) { return i.product_id; }).sort().join('-');
        if (box && box.getAttribute('data-key') === key) return;
        return pickUpsells(cart).then(function (prods) {
          var old = document.querySelector('.cart-upsell');
          if (old) old.remove();
          if (!prods.length) return;
          var t2 = target();
          if (!t2) return;
          var box2 = document.createElement('div');
          box2.className = 'cart-upsell';
          box2.setAttribute('data-key', key);
          var title = document.createElement('p');
          title.className = 'cart-upsell__title';
          title.textContent = 'Perfect together';
          box2.appendChild(title);
          prods.forEach(function (p) {
            var row = document.createElement('div');
            row.className = 'cart-upsell__item';
            var img = document.createElement('img');
            img.src = imgUrl(p);
            img.alt = '';
            img.loading = 'lazy';
            var info = document.createElement('span');
            info.className = 'cart-upsell__info';
            var a = document.createElement('a');
            a.className = 'cart-upsell__name';
            a.href = p.url ? p.url.split('?')[0] : '#';
            a.textContent = p.title;
            var price = document.createElement('span');
            price.className = 'cart-upsell__price';
            price.textContent = money(p.price);
            info.appendChild(a);
            info.appendChild(price);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'cart-upsell__add';
            btn.textContent = 'Add';
            btn.addEventListener('click', function () { addToCart(p, btn); });
            row.appendChild(img);
            row.appendChild(info);
            row.appendChild(btn);
            box2.appendChild(row);
          });
          t2.parent.insertBefore(box2, t2.before || null);
        });
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(update, 250);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
  update();

  /* Fallback hydration for complementary product-recommendations blocks */
  function hydrateRecommendations() {
    document.querySelectorAll('product-recommendations[data-intent="complementary"]').forEach(function (pr) {
      if (pr.__hydrating) return;
      if (pr.querySelector('a[href*="/products/"]')) return;
      pr.__hydrating = true;
      var url = pr.dataset.url + '&product_id=' + pr.dataset.productId + '&section_id=' + pr.dataset.sectionId + '&intent=' + pr.dataset.intent;
      fetch(url).then(function (r) { return r.ok ? r.text() : null; }).then(function (html) {
        pr.__hydrating = false;
        if (!html) return;
        if (pr.querySelector('a[href*="/products/"]')) return;
        var frag = new DOMParser().parseFromString(html, 'text/html');
        var freshPr = frag.querySelector('product-recommendations[data-intent="complementary"]');
        var list = pr.querySelector('.resource-list');
        var freshList = freshPr ? freshPr.querySelector('.resource-list') : null;
        if (list && freshList) {
          list.innerHTML = freshList.innerHTML;
          pr.dataset.recommendationsPerformed = 'true';
        }
      }).catch(function () { pr.__hydrating = false; });
    });
  }
  function applyGelatoDots() {
    var PINK = 'rgb(244, 167, 185)';
    document.querySelectorAll('div, section, header, aside').forEach(function (el) {
      if (el.classList.contains('gelato-dots')) return;
      if (el.parentElement && el.parentElement.closest('.gelato-dots')) return;
      if (getComputedStyle(el).backgroundColor !== PINK) return;
      var r = el.getBoundingClientRect();
      if (r.width < 250 || r.height < 30) return;
      el.classList.add('gelato-dots');
    });
    document.querySelectorAll('header-menu overflow-list').forEach(function (ol) {
      if (!ol.hasAttribute('disabled')) ol.setAttribute('disabled', 'true');
      Array.prototype.forEach.call(ol.children, function (li) { if (li.slot === 'overflow') li.removeAttribute('slot'); });
      ol.style.setProperty('--overflow-count', '0');
    });
    if (!window.matchMedia('(hover: none)').matches) {
      document.querySelectorAll('header-menu overflow-list[minimum-reached]').forEach(function (ol) { ol.removeAttribute('minimum-reached'); });
      var hc = document.getElementById('header-component');
      if (hc && hc.dataset.menuStyle !== 'menu') hc.dataset.menuStyle = 'menu';
    }
    document.querySelectorAll('.header__underlay').forEach(function (u) {
      if (u.dataset.gelatoDots) return;
      var bi = getComputedStyle(u).backgroundImage;
      if (bi.indexOf('244, 167, 185') === -1) return;
      u.dataset.gelatoDots = '1';
      u.style.backgroundImage = 'radial-gradient(rgba(255,255,255,.5) 1.6px, transparent 1.8px),radial-gradient(rgba(255,255,255,.28) 1.6px, transparent 1.8px),' + bi;
      u.style.backgroundSize = '26px 26px,26px 26px,auto';
      u.style.backgroundPosition = '0 0,13px 13px,0 0';
    });
  }
  function enforceMenu(){
    document.querySelectorAll('header-menu overflow-list').forEach(function(ol){
      if (!ol.hasAttribute('disabled')) ol.setAttribute('disabled','true');
      Array.prototype.forEach.call(ol.children, function(li){ if (li.slot === 'overflow') li.removeAttribute('slot'); });
      ol.style.setProperty('--overflow-count','0');
      if (ol.hasAttribute('minimum-reached')) ol.removeAttribute('minimum-reached');
    });
    if (!window.matchMedia('(hover: none)').matches){
      var hc = document.getElementById('header-component');
      if (hc && hc.dataset.menuStyle !== 'menu') hc.dataset.menuStyle = 'menu';
    }
  }
  enforceMenu();
  var __emN = 0; var __emT = setInterval(function(){ enforceMenu(); if (++__emN > 16) clearInterval(__emT); }, 300);
  var __hcEl = document.getElementById('header-component');
  if (__hcEl && window.MutationObserver){
    new MutationObserver(function(){ enforceMenu(); }).observe(__hcEl, {attributes:true, subtree:true, attributeFilter:['data-menu-style','minimum-reached','slot']});
  }
  applyGelatoDots();
  setTimeout(applyGelatoDots, 2500);
  setInterval(applyGelatoDots, 15000);
  window.addEventListener('scroll', function () { clearTimeout(window.__gdScrollT); window.__gdScrollT = setTimeout(applyGelatoDots, 250); }, { passive: true });

  setTimeout(hydrateRecommendations, 2000);
  setTimeout(hydrateRecommendations, 6000);
  setInterval(hydrateRecommendations, 15000);
})();